import { RegistrationMode } from '@easeltv/client-sdk';

import { useAuth } from '../../providers/AuthProvider/AuthProvider';
import { useConfig } from '../useConfig/useConfig';

/* --------------------------- useShowHeaderInAuth -------------------------- */

/**
 * useShowHeaderInAuth
 *
 * Provides the component with a flag as to whether or not a header should be shown
 *
 * This simple hook removes duplicate code
 *
 * @returns
 */
export const useShowHeaderInAuth = () => {
    const { isAuthenticated } = useAuth();

    // Grab registration mode
    const {
        registration: { mode },
    } = useConfig();

    // User logged in - shouldn't hit the auth pages
    if (isAuthenticated) return true;

    // User not logged int
    return (
        mode !== RegistrationMode.InviteOnly &&
        mode !== RegistrationMode.Required
    );
};
